export default __webpack_public_path__ + "static/media/spaceDuelImage1.be86ff05.png";